<template>
  <form action="">
    <div class="mb-2">
      <label for="exampleFormControlInput5">Principal</label>
      <select
        class="form-select"
        aria-label="Default select example"
        id="exampleFormControlInput5"
        placeholder="Company Name"
        v-model="form.compcode"
      >
        <option value="">=====</option>
        <option :value="n.compcode" v-for="(n, i) in listCompany" :key="i">
          {{ n.compname }}
        </option>
      </select>
    </div>
    <div class="mb-2">
      <label for="exampleFormControlInput1">Nama lengkap</label>
      <input
        type="text"
        class="form-control"
        id="exampleFormControlInput1"
        placeholder="Fullname"
        v-model="form.fullname"
      />
    </div>
    <div class="mb-2">
      <label for="exampleFormControlInput2">Username</label>
      <input
        type="text"
        autocomplete="username"
        class="form-control"
        id="exampleFormControlInput2"
        placeholder="Username"
        v-model="form.username"
      />
    </div>
    <div class="mb-2">
      <label for="exampleFormControlInput3">Password</label>
      <input
        type="password"
        autocomplete="current-password"
        class="form-control"
        id="exampleFormControlInput3"
        placeholder="Password"
        v-model="form.password"
      />
    </div>
    <div class="mb-2">
      <label for="exampleFormControlInput4">Level</label>
      <select
        class="form-select"
        aria-label="Default select example"
        id="exampleFormControlInput4"
        placeholder="Level"
        v-model="form.level"
      >
        <!-- <option value="1">Administrator</option> -->
        <option value="2">Marketing</option>
        <option value="3">Company</option>
      </select>
    </div>
    <div class="mb-2 text-end">
      <button
        type="button"
        class="btn btn-danger btn-sm m-1"
        @click="$store.commit('Users/SET_FORM', {})"
      >
        <i class="fa-solid fa-circle-xmark"></i> Batal
      </button>
      <button
        type="button"
        class="btn btn-primary btn-sm m-1"
        @click="$store.dispatch('Users/saveCreate')"
      >
        <i class="fa-solid fa-circle-plus"></i> Simpan
      </button>
    </div>
  </form>
</template>
<script>
export default {
  name: "UserCreateComponent",
  computed: {
    listCompany() {
      return this.$store.state.Company.listCompany;
    },
    form: {
      get() {
        return this.$store.state.Users.form;
      },
      set(value) {
        this.$store.commit("Users/SET_FORM", value);
      },
    },
  },
};
</script>
<style scoped></style>
